import Vue from 'vue';
import routes from './router';
import Router from 'vue-router';
import {get,post,post_Export} from '../store/vue_resource';
import {hasBtn,getBtnStatus,for_code,removeByIndex,removeByValue,getTime,getTime_us,getTime_zone,xunhaun,getTime_week,router_url,isMobile,detectZoom,getTime_us_f} from '../store/store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css';
if (isMobile()) {
	import("@/assets/wapstyle.css");
}else{
	import("@/assets/style.css");
}
import './assets/font_css/iconfont.css';


import App from './App';

// import EditorBar from '@/components/wangEnduit.vue'

import tinymce from '@/components/tinymce/index.vue'
Vue.component('EditorBar', tinymce)

import GeminiScrollbar from 'vue-gemini-scrollbar';
import VueResource from 'vue-resource';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import upload from '@/components/upload.vue'
import pagination from '@/components/pagination.vue'
Vue.component('upload',upload);
Vue.component('pagination',pagination);
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$post_Export = post_Export;
Vue.prototype.$getBtnStatus = getBtnStatus;
Vue.prototype.for_code = for_code;
Vue.prototype.hasBtn = hasBtn;
Vue.prototype.removeByIndex = removeByIndex;
Vue.prototype.removeByValue = removeByValue;
Vue.prototype.getTime = getTime;
Vue.prototype.getTime_us = getTime_us;
Vue.prototype.getTime_us_f = getTime_us_f;
Vue.prototype.getTime_zone = getTime_zone;
Vue.prototype.getTime_week = getTime_week;
Vue.prototype.router_url = router_url;
Vue.prototype.xunhaun = xunhaun;
Vue.config.productionTip = false;

import cCalendar from 'vue-c-calendar'
Vue.use(cCalendar)

Vue.use(ElementUI);
Vue.use(GeminiScrollbar);
Vue.use(VueResource);
Vue.component(CollapseTransition.name, CollapseTransition);
import i18n from './i18n/i18n';
var lang = localStorage.getItem('lang') || 'cn';
i18n.locale = lang;
Vue.prototype.lang = lang;




const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
	if (to.path == '/login') {
		sessionStorage.removeItem('TokenId');
	};
	let token = sessionStorage.getItem('TokenId');
	if (!token && to.path != '/login') {
		next({
			path: '/login'
		})
	} else if (to.path == '/') {
		next({
			path: '/parent_index'
		})
	} else {
		next()
	}
})
new Vue({
	el: '#app',
	i18n,
	router,
	components: {
		App
	},
	template: '<App/>'
})

// detectZoom();


// WEBPACK FOOTER //
// ./src/main.js